/**
 * Адаптер «старого» формата formio к формату, который ожидает SpilkaFormioMF.
 *
 * Старый эндпоинт getForm(formData) возвращает только массив компонентов,
 * а MF (как и новый getForm) работает с объектом
 * { success, components, submission, display, ... }.
 */

/**
 * @param {Array} components — массив компонентов formio (из $_getForm)
 * @param {Object} submissionData — начальные значения формы (черновик/предзаполнение)
 * @returns {Object} объект формы в формате SpilkaFormioMF
 */
export function toMfForm(components = [], submissionData = {}) {
  return {
    success: true,
    display: 'form',
    components: Array.isArray(components) ? components : [],
    submission: { data: submissionData || {} },
    settings: {},
    properties: {},
  }
}
